import { defineComponent as _defineComponent } from 'vue'
import { useUpdateTextMutation } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextFieldInput',
  props: {
  isEditable: {
    type: Boolean,
    default: true,
  },
  userInput: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;



const { mutate: updateText } = useUpdateTextMutation()

function valueChange(text: any) {
  updateText({
    userInputId: props.userInput.id,
    text,
  })
}

return { __sfc: true,props, updateText, valueChange }
}

})